import { z } from 'zod'

export const fundSourceSchema = z.object({
  id: z.coerce.number().optional(),
  name: z.string().min(1, 'Fund source name is required').max(100, 'Name must be less than 100 characters'),
  description: z.string().optional().nullable(),
  active: z.boolean().default(true),
  // Whether this source is physical cash (affects the shift expected-cash calc).
  is_cash: z.boolean().default(false),
  business_id: z.string().uuid('Invalid business ID'),
  created_at: z.date().optional(),
})

export type FundSource = z.infer<typeof fundSourceSchema>

// Schema for updating (all fields optional except id)
export const updateFundSourceSchema = fundSourceSchema
  .omit({ business_id: true, created_at: true })
  .partial()
  .required({ id: true })
  .transform((data) => {
    // Remove undefined values to only update provided fields
    const cleaned: Record<string, unknown> = { id: data.id }
    if (data.name !== undefined) cleaned.name = data.name
    if (data.description !== undefined) cleaned.description = data.description
    if (data.active !== undefined) cleaned.active = data.active
    if (data.is_cash !== undefined) cleaned.is_cash = data.is_cash
    return cleaned
  })

// Schema for creating (no id required)
export const createFundSourceSchema = fundSourceSchema.omit({ id: true, created_at: true })
